function openInNewTab(url, target = 'secure-ad-server-app-1') {
  if (!url) return;

  const newWindow = window.open(url, target);
  newWindow?.focus();
}

export { openInNewTab };
